export enum FreelancerType {
  W2 = 'W2',
  _1099 = '1099',
  BOTH = 'Both'
}
